import {
  ANR_ID,
  ANL_ID,
  ANS_ID,
  AGM_ID,
  AWF_ID,
  AKS_ID,
  APC_ID,
  AMI_ID,
  AKL_ID,
  AMS_ID,
  MVB_ID,
  MNB_ID,
} from "../constants/dealershipIds";
import { AGMQuizQuestions } from "../data/dealershipQuiz/AGMQuizQuestions";
import { AGMTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/AGMTestDrivePreApprovalForm";
import { AGMUpdateQuizQuestions } from "../data/dealershipQuiz/AGMUpdateProfileQuiz";
import { AMIQuizQuestions } from "../data/dealershipQuiz/AMIQuizQuestions";
import { AMITestDrivePreApprovalQuestions } from "../data/dealershipQuiz/AMITestDrivePreApprovalForm";
import { AMIUpdateQuizQuestions } from "../data/dealershipQuiz/AMIUpdateProfileQuiz";
import { AKSQuizQuestions } from "../data/dealershipQuiz/AKSQuizQuestions";
import { AKSTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/AKSTestDrivePreApprovalForm";
import { AKSUpdateQuizQuestions } from "../data/dealershipQuiz/AKSUpdateProfileQuiz";
import { ANLQuizQuestions } from "../data/dealershipQuiz/ANLQuizQuestions";
import { ANLTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/ANLTestDrivePreApprovalForm";
import { ANLUpdateQuizQuestions } from "../data/dealershipQuiz/ANLUpdateProfileQuiz";
import { ANRQuizQuestions } from "../data/dealershipQuiz/ANRQuizQuestions";
import { ANRTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/ANRTestDrivePreApprovalForm";
import { ANRUpdateQuizQuestions } from "../data/dealershipQuiz/ANRUpdateProfileQuiz";
import { ANSQuizQuestions } from "../data/dealershipQuiz/ANSQuizQuestions";
import { ANSTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/ANSTestDrivePreApprovalForm";
import { ANSUpdateQuizQuestions } from "../data/dealershipQuiz/ANSUpdateProfileQuiz";
import { AWFQuizQuestions } from "../data/dealershipQuiz/AWFQuizQuestions";
import { AWFTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/AWFTestDrivePreApprovalForm";
import { AWFUpdateQuizQuestions } from "../data/dealershipQuiz/AWFUpdateProfileQuiz";
import { APCQuizQuestions } from "../data/dealershipQuiz/APCQuizQuestions";
import { APCTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/APCTestDrivePreApprovalForm";
import { APCUpdateQuizQuestions } from "../data/dealershipQuiz/APCUpdateProfileQuiz";
import { AKLQuizQuestions } from "../data/dealershipQuiz/AKLQuizQuestions";
import { AKLTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/AKLTestDrivePreApprovalForm";
import { AKLUpdateQuizQuestions } from "../data/dealershipQuiz/AKLUpdateProfileQuiz";
import { AMSQuizQuestions } from "../data/dealershipQuiz/AMSQuizQuestions";
import { AMSTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/AMSTestDrivePreApprovalForm";
import { AMSUpdateQuizQuestions } from "../data/dealershipQuiz/AMSUpdateProfileQuiz";
import { MVBQuizQuestions } from "../data/dealershipQuiz/MVBQuizQuestions";
import { MVBTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/MVBTestDrivePreApprovalForm";
import { MVBUpdateQuizQuestions } from "../data/dealershipQuiz/MVBUpdateProfileQuiz";
import { MNBQuizQuestions } from "../data/dealershipQuiz/MNBQuizQuestions";
import { MNBTestDrivePreApprovalQuestions } from "../data/dealershipQuiz/MNBTestDrivePreApprovalForm";
import { MNBUpdateQuizQuestions } from "../data/dealershipQuiz/MNBUpdateProfileQuiz";
import { QuizQuestionsOptional } from "../data/dealershipQuiz/QuizQuestionsOptional";
import { MNBoptionalQuizQuestions } from "../data/dealershipQuiz/MNBOptionalQuizQuestions";
import { MVBOptionalQuizQuestions } from "../data/dealershipQuiz/MVBOptionalQuizQuestions";

export const DEALERSHIP_CONFIG = {
  trial: {
    name: "Your Dealership Name",
    imgUrl:
      "https://mae-trim-images.s3.us-east-2.amazonaws.com/Black+and+White+Illustrative+Auto+Dealership+Logo+Design+(2)+(1).png",
    linkMatchesToVDP: false,
    defaultInventoryImage:
      "https://mae-trim-images.s3.us-east-2.amazonaws.com/Black+and+White+Illustrative+Auto+Dealership+Logo+Design+(3).png",
  },
  [ANR_ID]: {
    name: "Applewood Nissan Richmond",
    imgUrl:
      "https://mae-trim-images.s3.us-east-2.amazonaws.com/WhatsApp+Image+2025-04-03+at+1.46.29+PM+(1).jpeg",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: ANRQuizQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    updateProfileQuizQuestions: ANRUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: ANRTestDrivePreApprovalQuestions,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    textingFinancingFormEnabled: true,
    dealershipInventoryIdList: [ANR_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [ANL_ID]: {
    name: "Applewood Nissan Langley",
    imgUrl: "https://images.app.ridemotive.com/nrvhw0q3y1rkhabunq0iiyt0js9u",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: ANLQuizQuestions,
    updateProfileQuizQuestions: ANLUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: ANLTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [ANL_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [ANS_ID]: {
    name: "Applewood Nissan Surrey",
    imgUrl: "https://images.app.ridemotive.com/rlctfgsirn9miossjj4mrvx0fb5c",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: ANSQuizQuestions,
    updateProfileQuizQuestions: ANSUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: ANSTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [ANS_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [APC_ID]: {
    name: "Applewood Performance Center",
    imgUrl:
      "https://static.cargurus.com/images/site/2025/05/14/15/41/applewood_performance_center-pic-8423734306134908380-200x200.jpeg",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: APCQuizQuestions,
    updateProfileQuizQuestions: APCUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: APCTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [APC_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [AGM_ID]: {
    name: "Applewood GM Port Hardy",
    imgUrl:
      "https://mae-sales-copilot-images.s3.us-east-1.amazonaws.com/Applewood-GM-Logo.webp",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: AGMQuizQuestions,
    updateProfileQuizQuestions: AGMUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: AGMTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    textingFinancingFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [AGM_ID, AWF_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [AWF_ID]: {
    name: "Applewood Ford",
    imgUrl:
      "https://mae-sales-copilot-images.s3.us-east-1.amazonaws.com/awf_logo.webp",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: AWFQuizQuestions,
    updateProfileQuizQuestions: AWFUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: AWFTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    textingFinancingFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [AWF_ID, AGM_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [AKS_ID]: {
    name: "Applewood Kia Surrey",
    imgUrl:
      "https://com-tekioncloud-cdms-global.s3.us-west-1.amazonaws.com/cdos-mobile/images/783e2c68-d970-4458-8764-217043bfc0ca_KS_Black.png",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: AKSQuizQuestions,
    updateProfileQuizQuestions: AKSUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: AKSTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    textingFinancingFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [AKS_ID],
    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [AMI_ID]: {
    name: "Applewood Mitsubishi",
    imgUrl:
      "https://listcarbrands.com/wp-content/uploads/2016/05/Logo-Mitsubishi.png",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: AMIQuizQuestions,
    updateProfileQuizQuestions: AMIUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: AMITestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [AMI_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [AKL_ID]: {
    name: "Applewood Kia Langley",
    imgUrl:
      "https://mae-sales-copilot-images.s3.us-east-1.amazonaws.com/applewood_langley_kia_logo.png",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: AKLQuizQuestions,
    updateProfileQuizQuestions: AKLUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: AKLTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    textingFinancingFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [AKL_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [AMS_ID]: {
    name: "Applewood Mazda Surrey",
    imgUrl:
      "https://di-uploads-pod19.dealerinspire.com/freewaymazda1/uploads/2025/04/Mazda_black-1.png",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: AMSQuizQuestions,
    updateProfileQuizQuestions: AMSUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: AMSTestDrivePreApprovalQuestions,
    optionalQuizQuestions: QuizQuestionsOptional,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [AMS_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [MVB_ID]: {
    name: "Morrey Volvo Cars Burnaby",
    imgUrl:
      "https://mae-sales-copilot-images.s3.us-east-1.amazonaws.com/morrey-volvo-burnaby.png",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: MVBQuizQuestions,
    updateProfileQuizQuestions: MVBUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: MVBTestDrivePreApprovalQuestions,
    optionalQuizQuestions: MVBOptionalQuizQuestions,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [MVB_ID],

    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
  [MNB_ID]: {
    name: "Morrey Nissan Burnaby",
    imgUrl:
      "https://mae-sales-copilot-images.s3.us-east-1.amazonaws.com/morrey-nissan-bunaby-logo.png",
    linkMatchesToVDP: true,
    defaultInventoryImage: false,
    salesPeople: {},
    quizQuestions: MNBQuizQuestions,
    updateProfileQuizQuestions: MNBUpdateQuizQuestions,
    testDrivePreapprovalQuizQuestions: MNBTestDrivePreApprovalQuestions,
    optionalQuizQuestions: MNBoptionalQuizQuestions,
    testDrivePreApprovalFormEnabled: true,
    applewoodRedTheme: true,
    dealershipInventoryIdList: [MNB_ID],
    redirectAfterCheckInQuizSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}testdrive?id=${userId}&email=${email}&audio=${recordingEnabled}`,
    redirectAfterTdAndPreApprovalSubmit: (
      dealershipId,
      userId,
      email,
      recordingEnabled,
      baseURL
    ) =>
      `${baseURL}matches?id=${userId}&email=${email}&audio=${recordingEnabled}`,
  },
};
